import React from "react";
import { Card, Button } from "react-bootstrap";
import { FiClock, FiDownload } from "react-icons/fi";

const schedules = [
  ["Mar","02","Product Designer","09:00 AM - 10:30 AM","avatar-01.png"],
  ["Apr","22","Marketing Manager","01:00 PM - 02:00 PM","avatar-02.png"],
  ["May","11","Sr. Data Science","11:00 AM - 12:30 PM","avatar-03.jpg"],
  ["Jun","07","Software Engineer","02:00 PM - 03:30 PM","avatar-04.png"],
  ["Aug","18","Financial Analyst","03:00 PM - 04:00 PM","avatar-05.png"],
];

export default function SchedulesUpcoming() {
  return (
    <Card className="schedule-card h-100">
      <Card.Body>

        {/* Header */}
        <div className="schedule-header">
          <h6>Upcoming Schedules</h6>

          <div className="download">
            <FiDownload className="me-1"/>
            <span>Last 30 Days</span>
          </div>
        </div>

        {/* Schedule List */}
        {schedules.map((s, i) => (
          <div className="schedule-item" key={i}>

            <div className="schedule-left">

              <div className="date-box">
                <span className="month">{s[0]}</span>
                <h6 className="day">{s[1]}</h6>
              </div>

              <div className="schedule-info">
                <p className="title">{s[2]}</p>
                <p className="time">
                  <FiClock /> {s[3]}
                </p>
              </div>

            </div>

            <img
              src={`/assets/img/avatar/${s[4]}`}
              alt=""
              className="avatar"
            />
          </div>
        ))}

        <Button className="view-btn border border-2 p-2">
          View All Schedule
        </Button>

      </Card.Body>

      <style>{`

        .schedule-card {
          border-radius: 5px;
          border: 2px solid #eee;
          box-shadow: 0 2px 6px rgba(0,0,0,0.05);
        }

        /* header */

        .schedule-header{
          display:flex;
          justify-content:space-between;
          align-items:center;
          margin-bottom:20px;
        }

        .schedule-header h5{
          font-weight:600;
          margin:0;
        }

        .download{
          font-size:13px;
          color:#777;
          display:flex;
          align-items:center;
          gap:5px;
        }
          
        .download:hover{
           color: #f97316 !important;
        }

        /* schedule item */

        .schedule-item{
          display:flex;
          justify-content:space-between;
          align-items:center;
          padding:10px 0;
          border-bottom:1px solid #f2f2f2;
        }

        .schedule-item:last-child{
          border-bottom:none;
        }

        .schedule-left{
          display:flex;
          gap:12px;
          align-items:center;
        }

        /* date */

        .date-box{
          border:1px solid #e6e6e6;
          border-radius:10px;
          width:55px;
          text-align:center;
          padding:6px 0;
          background:#fafafa;
        }

        .month{
          font-size:12px;
          color:#888;
          display:block;
        }

        .day{
          font-weight:600;
          margin:0;
        }

        /* text */

        .title{
          margin:0;
          font-weight:500;
          font-size:14px;
        }

        .time{
          margin:2px 0 0;
          font-size:13px;
          color:#888;
          display:flex;
          align-items:center;
          gap:5px;
        }

        /* avatar */

        .avatar{
          width:42px;
          height:42px;
          border-radius:50%;
          object-fit:cover;
        }

        /* button */

        .view-btn{
          width:100%;
          margin-top:18px;
          background:#ff6a2f;
          border:none;
          padding:10px;
          border-radius:6px;
          font-weight:500;
        }

        .view-btn:hover{
          background:#f97316 !important;
           color: #ffffff !important;
        }

        /* Mobile */

        @media (max-width:576px){

          .schedule-item{
            gap:10px;
          }

          .title{
            font-size:13px;
          }

          .time{
            font-size:12px;
          }

          .avatar{
            width:36px;
            height:36px;
          }

        }

      `}</style>
    </Card>
  );
}